// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ad":"ad-23w5zsj2"};